import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "unsupported-browser__browser" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", { href: "https://www.google.com/chrome/" }, "Google Chrome v.94+", -1)
const _hoisted_3 = { class: "unsupported-browser__browser" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", { href: "https://www.opera.com/" }, "Opera v.80+", -1)
const _hoisted_5 = { class: "unsupported-browser__browser" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", { href: "https://www.microsoft.com/en-us/edge" }, "Microsoft Edge v.94+", -1)

import UnsupportedPage from '@/components/unsupported-pages/UnsupportedPage.vue'
import GoogleChrome from '@/assets/GoogleChrome.svg'
import Opera from '@/assets/Opera.svg'
import MicrosoftEdge from '@/assets/MicrosoftEdge.svg'
import GtmHelper from '@/analytics/gtm-helper'

export default /*#__PURE__*/_defineComponent({
  __name: 'UnsupportedBrowser',
  setup(__props) {

GtmHelper.getInstance().triggerUnsupportedBrowserEvent()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UnsupportedPage, null, {
    title: _withCtx(() => [
      _createTextVNode(" This browser isn’t supported during beta - please try again with one of the supported browsers below. ")
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(GoogleChrome), { class: "unsupported-browser__browser-logo" }),
        _hoisted_2
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Opera), { class: "unsupported-browser__browser-logo" }),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(MicrosoftEdge), { class: "unsupported-browser__browser-logo" }),
        _hoisted_6
      ])
    ]),
    _: 1
  }))
}
}

})